import { useState, useEffect } from 'react';
import salesforceTasksService from 'services/salesforceTasksService';

// Loads Salesforce task form options (assignable users, statuses, priorities)
// once when enabled, then caches the result for the component lifetime.
// On failure, logs the error and exposes it via loadError so callers can
// react (e.g. show a notification and close the drawer).
const useTaskFormOptions = (enabled) => {
	const [formOptions, setFormOptions] = useState(null);
	const [formOptionsLoading, setFormOptionsLoading] = useState(false);
	const [loadError, setLoadError] = useState(null);

	useEffect(() => {
		if (!enabled || formOptions) {
			return;
		}

		let isCurrent = true;

		const load = async () => {
			setFormOptionsLoading(true);

			try {
				const options = await salesforceTasksService.getFormOptions();

				if (isCurrent) {
					setFormOptions(options);
				}
			} catch (error) {
				console.error('Failed to load Salesforce task form options:', error);

				if (isCurrent) {
					setLoadError(error);
				}
			} finally {
				if (isCurrent) {
					setFormOptionsLoading(false);
				}
			}
		};

		load();

		return () => {
			isCurrent = false;
		};
	}, [enabled, formOptions]);

	return { formOptions, formOptionsLoading, loadError };
};

export default useTaskFormOptions;
